/**
 * Debounce function to limit the rate at which a function can fire. This is useful for search input to prevent firing on every keystroke.
 * 
 * @param func callback function
 * @param wait time to wait
 * @returns debounced function
 */
export function debounce<T extends (...args: any[]) => any>(func: T, wait: number): (...args: Parameters<T>) => void {
  let timeout: number | undefined;

  return function(this: ThisParameterType<T>, ...args: Parameters<T>): void {
    const context = this;
    clearTimeout(timeout); // Clear the previous timeout
    timeout = window.setTimeout(() => {
      func.apply(context, args); // Call the original function with the correct context and arguments
    }, wait);
  };
}